import { render, staticRenderFns } from "./player-advancement-panel.vue?vue&type=template&id=b44ce4ba&scoped=true&"
import script from "./player-advancement-panel.vue?vue&type=script&lang=js&"
export * from "./player-advancement-panel.vue?vue&type=script&lang=js&"
import style0 from "./player-advancement-panel.vue?vue&type=style&index=0&id=b44ce4ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44ce4ba",
  null
  
)

export default component.exports